import React from "react";
import { Typography, Button, Select } from "antd";
import moment from "moment";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";
const { Option } = Select;
const { Title } = Typography;

const Header = (props) => {
  const {
    currentDate,
    onNextDate,
    onPreviousDate,
    clients,
    employees,
    onEmployeeChanged,
    onClientChanged,
    selectedClientId,
    selectedEmployeeId,
  } = props;
  const intl = useIntl();

  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div style={{ display: "flex", paddingBottom: "10px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            width: "200px",
            paddingBottom: "5px",
          }}
        >
          <Button
            type="text"
            shape="circle"
            icon={<RightOutlined />}
            onClick={onPreviousDate}
          />
          <Title level={4} style={{ margin: "0px", lineHeight: 1.5 }}>
            {moment(currentDate).format("MMMM YYYY")}
          </Title>
          <Button
            type="text"
            shape="circle"
            icon={<LeftOutlined />}
            onClick={onNextDate}
          />
        </div>
        <div style={{ width: "40px" }} />
        <Select
          style={{ width: 200 }}
          value={selectedClientId}
          onChange={onClientChanged}
          placeholder={intl.formatMessage({
            id: "app.work_diary_print.selectClient",
          })}
        >
          {clients.map((m) => (
            <Option key={m.orderId} value={m.orderId}>
              {m.name}
            </Option>
          ))}
        </Select>
        <div style={{ width: "40px" }} />

        <Select
          style={{ width: 200 }}
          value={selectedEmployeeId}
          onChange={onEmployeeChanged}
          placeholder={intl.formatMessage({
            id: "app.work_diary_print.selectEmployee",
          })}
        >
          {employees.map((m) => (
            <Option key={m.id} value={m.id}>
              {m.name}
            </Option>
          ))}
        </Select>
      </div>
    </div>
  );
};

export default Header;
